import image from '../../icons/image.svg'
import Dashboard from './Dashboard.vue'

export default {
  name: 'image',
  title: '图片',
  icon: image,
  dashboard: Dashboard,
  config: {
    sizeLimit: 512 * 1024, // 512k
    upload: {
      url: null,
      headers: {},
      params: {},
      fieldName: {}
    },
    compress: {
      width: 1600,
      height: 1600,
      quality: 80
    },
    uploadHandler (responseText) {
      const json = JSON.parse(responseText)
      return json.ok ? json.data : null
    }
  }
}
